import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import LazyImage from '../../../../ui-core/Image';
import {
  Mobility1,
  Mobility1Webp,
  Mobility2,
  Mobility2Webp,
} from '../../images';

import './style.css';
import Button from '../../../../ui-core/Button/Button';
import { TEXT_CONSTANT } from '../../../../constants/app';
import { addAosAnimateClassObserver } from '../../../../utils/helpers';

export const MobilityDetails = ({ isLoading, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(
        TEXT_CONSTANT.JOIN_NOW,
        'isSignup',
        `Come join me, Dr. Jen Fraboni, a Doctor of Physical Therapy, as I
        help you set a new foundation over the next 30 days in our Mobility
        Foundations Course.`,
      );
    }
  };

  const elementRef = useRef();
  const imgRef = useRef();
  const bottomContainerRef = useRef();
  useEffect(() => {
    const observer = addAosAnimateClassObserver();
    if (elementRef?.current) {
      observer.observe(elementRef.current);
    }
    if (imgRef?.current) {
      observer.observe(imgRef.current);
    }
    if (bottomContainerRef?.current) {
      observer.observe(bottomContainerRef.current);
    }

    return () => {
      elementRef?.current && observer.unobserve(elementRef?.current);
      imgRef?.current && observer.unobserve(imgRef?.current);
      bottomContainerRef?.current &&
        observer.unobserve(bottomContainerRef?.current);
    };
  }, []);
  return (
    <div
      ref={elementRef}
      className="mobility-details align-items-center"
      data-aos="fade-in"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      <Row className="sec-1">
        <Col lg="7" className="order-2 pe-xl-5">
          <h3>
            <em className="clr">Mobility</em>, or the{' '}
            <em>ability to actively</em> control the available range of motion
            within your joints, is the baseline from which we move!
          </h3>
          <p>
            Mobility does not just mean passive stretching for 30 seconds or
            just using a strap to try to force your body into a new range. And
            we do not need an hour/day to create effective change. Whether
            you&lsquo;re a hypermobile person with constant aches & pains or a
            walking tin man who can&lsquo;t reach your toes, mobility is
            important for everyone.
          </p>
        </Col>
        <Col
          ref={imgRef}
          lg="4"
          className="order-sm-2 image-mobility-1 position-relative offset-lg-1"
          data-aos="fade-left"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
        >
          <LazyImage
            errorSrc={Mobility1}
            placeholderSrc={Mobility1Webp}
            src={Mobility1Webp}
            className="w-100 img-fluid"
          />
          <div className="clr-bg"></div>
        </Col>
      </Row>

      <Row
        ref={bottomContainerRef}
        className="sec-2"
        data-aos="fade-up"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
      >
        <Col md="6" lg="4" className="position-relative offset-lg-1 ps-4">
          <LazyImage
            errorSrc={Mobility2}
            placeholderSrc={Mobility2Webp}
            src={Mobility2Webp}
            className="w-100 img-fluid"
          />
        </Col>
        <Col
          md="6"
          lg="7"
          className="d-flex flex-column d-sm-block mobile-index"
        >
          <h3>
            Come join me, Dr. Jen Fraboni, a Doctor of Physical Therapy, as I
            help you set a new foundation over the next 30 days in our Mobility
            Foundations Course.
          </h3>
          <Button
            type="button"
            class="site-btn-stroke hover-white"
            isLoading={isLoading}
            disabled={isLoading}
            text={TEXT_CONSTANT.JOIN_NOW}
            onClick={handleClick}
          />
        </Col>
      </Row>
    </div>
  );
};

MobilityDetails.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};
